import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import ConfimeaHeader from './components/ConfimeaHeader';
import ConfimeaHero from './components/ConfimeaHero';
import ConfimeaBenefits from './components/ConfimeaBenefits';
import ConfimeaHowItWorks from './components/ConfimeaHowItWorks';
import ConfimeaCTA from './components/ConfimeaCTA';
import ConfimeaForm from './components/ConfimeaForm';
import ConfimeaPartnership from './components/ConfimeaPartnership';
import ConfimeaFAQ from './components/ConfimeaFAQ';
import ConfimeaContact from './components/ConfimeaContact';
import ConfimeaFooter from './components/ConfimeaFooter';
import ogImage from '../images/confimea-imprese.png';
import './Confimea.css';

const Confimea = () => {
  const location = useLocation();
  const seoImageUrl = `${window.location.origin}${ogImage}`;
  const canonicalUrl = 'https://extraconomy.com/confimeaimprese';
  const faviconUrl = `${process.env.PUBLIC_URL}/assets/icons/confimea-fav.png`;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Confimea Imprese – Attiva il tuo Profilo Manager",
    "description": "Pagina ufficiale della Confimea Imprese per l'attivazione del profilo Manager sulla piattaforma digitale.",
    "url": canonicalUrl,
    "inLanguage": "it-IT",
    "isPartOf": {
      "@type": "WebSite",
      "name": "Extraconomy",
      "url": "https://extraconomy.com"
    },
    "about": [
      {
        "@type": "Organization",
        "name": "Confimea Imprese"
      },
      {
        "@type": "Organization",
        "name": "Extraconomy"
      }
    ]
  };

  useEffect(() => {
    const shouldScrollToForm =
      location.hash === "#form" ||
      new URLSearchParams(location.search).has("association");

    if (!shouldScrollToForm) return undefined;

    const scrollToForm = () => {
      document.getElementById("form")?.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const timer = window.setTimeout(scrollToForm, 150);
    return () => window.clearTimeout(timer);
  }, [location.hash, location.search]);

  return (
    <>
      <Helmet>
        <title>Extraconomy & Confimea Imprese – Attiva il tuo Profilo Manager</title>

        <link rel="icon" type="image/png" href={faviconUrl} />
        <link rel="shortcut icon" type="image/png" href={faviconUrl} />

        <meta name="description" content="Attiva il tuo accesso digitale Confimea Imprese: cashback, fidelizzazione, analytics e certificazione digitale per le imprese associate." />

        <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />

        <link rel="canonical" href={canonicalUrl} />

        <meta httpEquiv="content-language" content="it-IT" />

        <link rel="alternate" hreflang="it-IT" href={canonicalUrl} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Extraconomy" />
        <meta property="og:title" content="Confimea Imprese – Attiva il tuo Profilo Manager" />
        <meta property="og:description" content="Piattaforma digitale riservata alle imprese associate a Confimea Imprese per cashback, fidelizzazione e analytics nel settore imprenditoriale." />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:image" content={seoImageUrl} />
        <meta property="og:image:alt" content="Confimea Imprese" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Confimea Imprese – Attiva il tuo Profilo Manager" />
        <meta name="twitter:description" content="Strumenti digitali per fidelizzazione, cashback e analytics dedicati alle imprese associate a Confimea Imprese." />
        <meta name="twitter:image" content={seoImageUrl} />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      </Helmet>

      <div className="confimea-page">
      <ConfimeaHeader />
      <ConfimeaHero />
      <ConfimeaBenefits />
      <ConfimeaHowItWorks />
      <ConfimeaCTA />
      <ConfimeaForm />
      <ConfimeaPartnership />
      <ConfimeaFAQ />
      <ConfimeaContact />
      <ConfimeaFooter />
      </div>
    </>
  );
};

export default Confimea;


